export function createEmpleado() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    EsActivo: true,
    UsuarioId: '',
    Clave2: ''
  };
}
